import { render, staticRenderFns } from "./AlertsLeftSide.vue?vue&type=template&id=5ea39a52"
import script from "./AlertsLeftSide.vue?vue&type=script&lang=js"
export * from "./AlertsLeftSide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports